import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-in-columns",
  "use": "icon-si-glyph-in-columns-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-in-columns\" id=\"icon-si-glyph-in-columns\"><title>1232</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"12.9979248\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"0\" width=\"4\" height=\"12.9727783\" class=\"si-glyph-fill\" /><rect x=\"10\" y=\"0\" width=\"4\" height=\"13.0186768\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-in-columns.svg
// module id = BDc5
// module chunks = 62